// Aligned with backend Prisma schema
export type ResourceType = 
  | 'VET'
  | 'CLINIC'
  | 'SHELTER_PRIVATE'
  | 'SHELTER_GOVERNMENT'
  | 'HELPLINE'
  | 'FEEDING_SPOT'
  | 'PET_SHOP'
  | 'NGO'
  | 'AMBULANCE'
  | 'SPECIALIZED_SERVICE'
  | 'VOLUNTEER_NETWORK'
  | 'VETERINARY'
  | 'SHELTER'
  | 'PET_STORE'
  | 'EMERGENCY'
  | 'GOVERNMENT'
  | 'OTHER';

// Mapping for display purposes
export const RESOURCE_TYPE_LABELS: Record<ResourceType, string> = {
  VET: 'Veterinary Clinic',
  CLINIC: 'Clinic',
  SHELTER_PRIVATE: 'Private Shelter',
  SHELTER_GOVERNMENT: 'Government Shelter',
  HELPLINE: 'Helpline',
  FEEDING_SPOT: 'Feeding Spot',
  PET_SHOP: 'Pet Shop',
  NGO: 'NGO',
  AMBULANCE: 'Ambulance',
  SPECIALIZED_SERVICE: 'Specialized Service',
  VOLUNTEER_NETWORK: 'Volunteer Network',
  VETERINARY: 'Veterinary',
  SHELTER: 'Shelter',
  PET_STORE: 'Pet Store',
  EMERGENCY: 'Emergency Service',
  GOVERNMENT: 'Government',
  OTHER: 'Other',
};

// Grouped types for better UI organization
export const RESOURCE_TYPE_GROUPS = {
  medical: ['VET', 'VETERINARY', 'CLINIC', 'AMBULANCE', 'EMERGENCY'] as ResourceType[],
  shelter: ['SHELTER', 'SHELTER_PRIVATE', 'SHELTER_GOVERNMENT'] as ResourceType[],
  community: ['NGO', 'VOLUNTEER_NETWORK', 'FEEDING_SPOT'] as ResourceType[],
  commercial: ['PET_SHOP', 'PET_STORE', 'SPECIALIZED_SERVICE'] as ResourceType[],
  support: ['HELPLINE', 'GOVERNMENT'] as ResourceType[],
  other: ['OTHER'] as ResourceType[],
};

export interface Resource {
  id: string;
  name: string;
  type: ResourceType;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  isActive: boolean;
  isVerified: boolean;
  website?: string;
  openingHours?: string;
  description?: string;
  specialties: string[];
  services: string[];
  governmentId?: string;
  certifications: string[];
  serviceRadius?: number;
  responseTime?: string;
  capacity?: number;
  vehicleType?: string;
  priceRange?: string;
  socialLinks: string[];
  joinLink?: string;
  groupSize?: number;
  focusAreas: string[];
  // Google Places integration fields
  googlePlaceId?: string;
  rating?: number;
  totalRatings?: number;
  businessHours?: string;
  dataSource?: string;
  businessStatus?: string;
  verifiedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ResourceStats {
  totalResources: number;
  activeResources: number;
  verifiedResources: number;
  typeBreakdown: { type: string; count: number }[];
}
